import React from 'react'
import { useState,useEffect } from 'react';
import { Stack,Typography,Box } from '@mui/material';
import {Fetch} from './Fetch'
import Sidebar from './Sidebar';
import Videos from './Videos'


const Feed = () => {
  const[category,setCategory]=useState('New');
  const[response,setResponse]= useState([]);
useEffect(()=>{
Fetch(`search?part=snippet&q=${category}&maxResults=50`).then((data)=>{setResponse(data?.items)})
.catch((err)=>{console.log(err)});
},[category])

  return (
    <Stack sx={{flexDirection:{sm:'column',md:'row'},backgroundColor:'white'}}>
       <Box
      sx={{
        height: {sm:'auto',md:'92vh'},
        px:{sx:0,md:2},
        borderRight:'1px solid black',
      }}>
        <Sidebar category={setCategory}/>
       
        </Box>

        <Box p={2} sx={{
          overflowY:'auto',
          height:'90vh',
          flex:2
        }}>
       
        <Videos data={response}/>

        </Box>
   
   
   
    </Stack>
  )
}

export default Feed